"use client";

import {
  Accordion,
  AccordionContent,
  AccordionItem,
} from "@workspace/ui/components/accordion";
import { Button } from "@workspace/ui/components/button";
import { useState } from "react";

type LoginAccordionProps = {
  children: React.ReactNode;
};

export function LoginAccordion({ children }: LoginAccordionProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Accordion
      className="w-full"
      collapsible
      onValueChange={(value) => setIsOpen(value === "other-options")}
      type="single"
      value={isOpen ? "other-options" : ""}
    >
      <AccordionItem className="border-0" value="other-options">
        <Button
          className="w-full"
          onClick={() => setIsOpen((open) => !open)}
          type="button"
          variant="outline"
        >
          {isOpen ? "Hide other options" : "Show other options"}
        </Button>
        <AccordionContent className="pt-4">
          <div className="space-y-3">{children}</div>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
}
